import React from 'react';
import Header from '../components/Header/Header';
import ForecastingHero from '../components/ForecastingHero/ForecastingHero';
import ForecastMethodology from '../components/ForecastMethodology/ForecastMethodology';
import Footer from '../components/Footer/Footer';
import PriceForecast from '../components/PriceForecast/PriceForecast';
import AccuracyModels from '../components/AccuracyModels/AccuracyModels';
import Correlation from '../components/Correlation/Correlation';
import ForecastCoverage from '../components/ForecastCoverage/ForecastCoverage'; 
import ForecastingMatters from '../components/ForecastingMatters/ForecastingMatters';
import FooterCTA from '../components/FooterCTA/FooterCTA';

const ForecastingPage = () => {
  return (
    <>
      <Header />
      <main>
        <ForecastingHero />
        <ForecastMethodology />
        <PriceForecast />
        <AccuracyModels />
        <Correlation />
        <ForecastCoverage />
        {/* You can add more forecasting-specific content here later */}
        <ForecastingMatters />
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default ForecastingPage;